import React from "react"
import PropTypes from "prop-types"

import Footer from "../../components/Footer/"
import SecondaryNav from "../../components/SecondaryNav"
import LostAssetsReport from "../../components/LostAssetsReport/LostAssetsReportWithData"
import LowBatteryReport from "../../components/LowBatteryReport/LowBatteryReportWithData"

import AllAssetsReport from "../../components/AllAssetsReport/AllAssetsReportWithData"

import "./ReportView.scss"

class ReportView extends React.Component {
  render() {
    const updatedPath = this.props.match.path.replace(
      ":facilityId",
      this.props.match.params.facilityId
    )
    const reportTabs = [
      {
        label: "Lost Assets",
        path: updatedPath.replace(":reportName", "lost"),
        reportName: `lost`,
        component: LostAssetsReport,
      },
      {
        label: "Low Battery Tags",
        path: updatedPath.replace(":reportName", "low-battery"),
        reportName: "low-battery",
        component: LowBatteryReport,
      },

      {
        label: "All Asset Tags",
        path: updatedPath.replace(":reportName", "all-assets"),
        reportName: "all-assets",
        component: AllAssetsReport,
      },
    ]
    const activeTab =
      reportTabs.find(
        tab => this.props.match.params.reportName === tab.reportName
      ) || reportTabs[0]
    return (
      <div className="report-view-container">
        <div>
          <h1>Reports</h1>
          <hr />
          <SecondaryNav
            className="report-selector"
            tabs={reportTabs}
            activeTab={activeTab.label}
          />
          <activeTab.component
            facilityId={this.props.match.params.facilityId}
            deviceType={this.props.deviceType}
          />
          <Footer />
        </div>
      </div>
    )
  }
}

ReportView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      facilityId: PropTypes.string.isRequired,
      reportName: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  deviceType: PropTypes.string.isRequired,
}

ReportView.defaultProps = {
  deviceType: "desktop",
}

export default ReportView
